<template>
    <div class="w-[1440px] mx-auto space-y-8">
      <!-- 双栏容器 -->
      <div class="flex gap-6">
        <!-- 进货渠道 -->
        <main class="bg-white rounded-lg shadow-sm p-6 flex-1 transition-all duration-200 hover:shadow-md">
          <div class="mb-6">
            <div class="relative">
              <input
                v-model="searchText1"
                type="text"
                placeholder="从哪出货"
                  @keyup.enter="handleShipmentSearch1"
                class="w-full h-10 pl-10 pr-4 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent text-sm"
              >
              <i class="fas fa-search absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-sm"></i>
            </div>
          </div>
  
          <!-- 仓库列表 -->
          <div class="grid gap-3" style="overflow-y: auto;height: 300px;">
            <div
              v-for="item in data1"
              :key="item.supply_id"
                @click="choose1(item)"
              class="p-4 border rounded-lg cursor-pointer transition-colors"
              style="max-height:100px;"
              :class="{
                'border-primary bg-blue-50': selectedWarehouseId_c === item.supply_id,
                'border-gray-100 hover:border-primary': selectedWarehouseId_c !== item.supply_id
              }"
            >
              <div class="flex items-start gap-3">
                <i class="fas fa-warehouse text-primary mt-1 text-lg"></i>
                <div class="flex-1 min-w-0">
                  <h3 class="font-medium truncate">{{ item.name }}</h3>
                  <p class="text-sm text-gray-500 mt-1">类型：{{ item.kmdGrade.name }}</p>
                  <p class="text-sm text-gray-500 mt-1">位置：{{ item.address }}</p>
                </div>
              </div>
            </div>
          </div>
        </main>
  
        <!-- 出货渠道 -->
        <main  v-if="type == 2" class="bg-white rounded-lg shadow-sm p-6 flex-1 transition-all duration-200 hover:shadow-md">
          <div class="mb-6">
            <div class="relative">
              <input
                v-model="searchText2"

                type="text"
                placeholder="出货到哪"
               @keyup.enter="handleShipmentSearch2"
                class="w-full h-10 pl-10 pr-4 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent text-sm"
              >
              
            </div>
          </div>
  
          <!-- 仓库列表 -->
          <div class="grid gap-3" style="overflow-y: auto;height: 300px;">
            <div
              v-for="item in data2"
              :key="item.supply_id"
              @click="choose2(item)"
              class="p-4 border rounded-lg cursor-pointer transition-colors"
                        style="max-height:100px;"
              :class="{
                'border-primary bg-blue-50': selectedWarehouseId_r === item.supply_id,
                'border-gray-100 hover:border-primary': selectedWarehouseId_r !== item.supply_id
              }"
            >
              <div class="flex items-start gap-3">
                <i class="fas fa-warehouse text-primary mt-1 text-lg"></i>
                <div class="flex-1 min-w-0">
                  <h3 class="font-medium truncate">{{ item.name }}</h3>
                  <p class="text-sm text-gray-500 mt-1">类型：{{ item.kmdGrade.name }}</p>
                  <p class="text-sm text-gray-500 mt-1">位置：{{ item.address }}</p>
                </div>
              </div>
            </div>
          </div>
        </main>



        <main  v-if="type == 3" class="bg-white rounded-lg shadow-sm p-6 flex-1 transition-all duration-200 hover:shadow-md">
          <div class="mb-6">
            <div class="relative">
              <input
                v-model="searchText3"

                type="text"
                placeholder="下单门店"
               @keyup.enter="handleShipmentSearch3"
                class="w-full h-10 pl-10 pr-4 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent text-sm"
              >
              
            </div>
          </div>
  
          <!-- 仓库列表 -->
          <div class="grid gap-3" style="overflow-y: auto;height: 300px;">
            <div
              v-for="item in data3"
              :key="item.store_id"
              @click="choose3(item)"
              class="p-4 border rounded-lg cursor-pointer transition-colors"
                        style="max-height:100px;"
              :class="{
                'border-primary bg-blue-50': selectedWarehouseId_s === item.store_id,
                'border-gray-100 hover:border-primary': selectedWarehouseId_s !== item.store_id
              }"
            >
              <div class="flex items-start gap-3">
                <i class="fas fa-warehouse text-primary mt-1 text-lg"></i>
                <div class="flex-1 min-w-0">
                  <h3 class="font-medium truncate">{{ item.store_name }}</h3>
                  <p class="text-sm text-gray-500 mt-1">位置：{{ item.address }}</p>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  </template>
  
  <script>
    import PorductApi from '@/api/product.js';
    export default {
    name: 'App',
    data() {
    return {

            selectedWarehouseId_r:0,
            selectedWarehouseId_c:0,
            selectedWarehouseId_s:0,
            data1:[],
            data2:[],
            data3:[],
            searchText1:"",
            searchText2:"",
            searchText3:"",

            searchText: '',
            showWarehouseDropdown: false,
            showLocationDropdown: false,
            selectedId: null,
            selectedLocationId: null,
        }
    },
    props:['data','type'],

    created(){
        console.log('');
        this.getBatchs1();
        this.getBatchs2();
        this.getBatchs3();
    },

    methods: {
        handleShipmentSearch1(){
            this.getBatchs1();
        },
        handleShipmentSearch2(){
            this.getBatchs2();
        },
        handleShipmentSearch3(){
            this.getBatchs3();
        },
        choose1(item){
            this.selectedWarehouseId_c = item.supply_id
            this.$emit('choose1', {
                id: item.supply_id,
            });
         
      
        },
        choose2(item){
            this.selectedWarehouseId_r = item.supply_id
            this.$emit('choose2', {
                id: item.supply_id,
            });
        
        },
        choose3(item){
            this.selectedWarehouseId_s = item.store_id
            this.$emit('choose3', {
                id: item.store_id,
            });
        
        },
        getBatchs1(){
            var self = this;
            var params1 = {
                search:self.searchText1,
                type:1
            }
            PorductApi.getBatchs(params1, true)
            .then(res => {
                if (res.code == 1) {
                self.loading = false;
                self.data1 = res.data;
                }
            })
          .catch(error => {});



        },
        getBatchs2(){
            var self = this;


          var params1 = {
                search:self.searchText2,
                type:2
            }
            PorductApi.getBatchsx(params1, true)
            .then(res => {
                if (res.code == 1) {
                self.loading = false;
                self.data2 = res.data;
                }
            })
          .catch(error => {});



        },
        getBatchs3(){
            var self = this;


          var params1 = {
                search:self.searchText3,
                type:3
            }
            PorductApi.getBatchsx(params1, true)
            .then(res => {
                if (res.code == 1) {
                self.loading = false;
                self.data3 = res.data;
                }
            })
          .catch(error => {});



        },
        toggleWarehouseDropdown() {
            this.showWarehouseDropdown = !this.showWarehouseDropdown
            this.showLocationDropdown = false
        },
        toggleLocationDropdown() {
            this.showLocationDropdown = !this.showLocationDropdown
            this.showWarehouseDropdown = false
        },
    
    }
    }
    </script>
    <style scoped>
    body {
    min-height: 1024px;
    }
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
    }
    .warehouse-dropdown,
    .location-dropdown {
    max-height: 300px;
    overflow-y: auto;
    }
    </style>
    


// WEBPACK FOOTER //
// src/components/supply/new/supply.vue